var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-item" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-xs-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Заголовок")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.video.title,
                expression: "video.title",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", required: "" },
            domProps: { value: _vm.video.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.video, "title", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-xs-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Идентификатор или URL")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.video.id,
                expression: "video.id",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", required: "" },
            domProps: { value: _vm.video.id },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.video, "id", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-xs-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Описание")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.video.description,
                expression: "video.description",
              },
            ],
            staticClass: "form-control",
            domProps: { value: _vm.video.description },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.video, "description", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-xs-6" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-danger",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.deleteVideo(_vm.index)
              },
            },
          },
          [
            _c("i", { staticClass: "icon-fa icon-fa-trash" }),
            _vm._v(" Удалить видео"),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }